// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyA6YtYIdMmMTmvaJUuKm4AAPR7p9Jc-QWg',
    authDomain: 'bibo-app.firebaseapp.com',
    databaseURL: 'https://bibo-app.firebaseio.com',
    projectId: 'bibo-app',
    storageBucket: 'bibo-app.appspot.com',
    messagingSenderId: '464799081519',
    appId: '1:464799081519:web:2302b35e140f29c81ad2da',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
